<template>
    <div class="loader" id="loaderWave">
<div class = "centered">
	<div class = "blob-1"></div>
	<div class = "blob-2"></div>
</div>
</div>

</template>
<script>


    export default {
        name: 'animated-loader'

    }
</script>
<style>
    
    

  .loader {
    background-color: #000630;
    position: absolute;
    z-index: 2000;
    width: 100vw;
    overflow: hidden;
    height: 100vh;

  }

.centered{
	width:400px;
	height:400px;
	position:absolute;
	top:50%;
	left:50%;
	transform:translate(-50%,-50%);
	/*background:hsl(232, 92%, 30%);*/
	/*filter: blur(10px) contrast(20);*/
}
.blob-1,.blob-2{
	width:140px;
	height:140px;
	position:absolute;
	background:#0637EB;
	border-radius:50%;
	top:50%;left:50%;
	transform:translate(-50%,-50%);
}
.blob-1{
	left:20%;
	animation:osc-l 3s infinite;
}
.blob-2{
	left:80%;
	animation:osc-r 3s infinite;
	background:#0ff;
}
@keyframes osc-l{
	0%{left:20%;}
	50%{left:50%;height: 200px;width: 200px}
	100%{left:20%;}
}
@keyframes osc-r{
	0%{left:80%;}
	50%{left:50%;width:35px;height: 35px;}
	100%{left:80%;}
}
</style>